/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData } from './FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData';
import {
    FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData';
import type { FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData } from './FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData';
import {
    FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData';
import type { FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData } from './FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData';
import {
    FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData';
import type { FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData } from './FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData';
import {
    FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData';
import type { FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct } from './FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct';
import {
    FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct';
import type { FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData } from './FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData';
import {
    FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSON,
    FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSONTyped,
} from './FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData';

/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppInAppValidationRequest
 */
export interface FxIdApplicationStoreInAppInAppValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    Type: string;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    OneStoreInAppBillingData?: FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData | null;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    RuStoreValidateProduct?: FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct | null;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    GoogleInAppBillingData?: FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData | null;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    AppStoreInAppBillingData?: FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingData | null;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    SteamInAppBillingData?: FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData | null;
    /**
     * 
     * @type {FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData}
     * @memberof FxIdApplicationStoreInAppInAppValidationRequest
     */
    EgsInAppBillingData?: FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingData | null;
}

/**
 * Check if a given object implements the FxIdApplicationStoreInAppInAppValidationRequest interface.
 */
export function instanceOfFxIdApplicationStoreInAppInAppValidationRequest(value: object): value is FxIdApplicationStoreInAppInAppValidationRequest {
    if (!('Type' in value) || value['Type'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppInAppValidationRequestFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequest {
    return FxIdApplicationStoreInAppInAppValidationRequestFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Type': json['Type'],
        'OneStoreInAppBillingData': json['OneStoreInAppBillingData'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSON(json['OneStoreInAppBillingData']),
        'RuStoreValidateProduct': json['RuStoreValidateProduct'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSON(json['RuStoreValidateProduct']),
        'GoogleInAppBillingData': json['GoogleInAppBillingData'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSON(json['GoogleInAppBillingData']),
        'AppStoreInAppBillingData': json['AppStoreInAppBillingData'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataFromJSON(json['AppStoreInAppBillingData']),
        'SteamInAppBillingData': json['SteamInAppBillingData'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSON(json['SteamInAppBillingData']),
        'EgsInAppBillingData': json['EgsInAppBillingData'] == null ? undefined : FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataFromJSON(json['EgsInAppBillingData']),
    };
}

export function FxIdApplicationStoreInAppInAppValidationRequestToJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequest {
    return FxIdApplicationStoreInAppInAppValidationRequestToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Type': value['Type'],
        'OneStoreInAppBillingData': FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSON(value['OneStoreInAppBillingData']),
        'RuStoreValidateProduct': FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSON(value['RuStoreValidateProduct']),
        'GoogleInAppBillingData': FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSON(value['GoogleInAppBillingData']),
        'AppStoreInAppBillingData': FxIdApplicationStoreInAppInAppValidationRequestAppStoreInAppBillingDataToJSON(value['AppStoreInAppBillingData']),
        'SteamInAppBillingData': FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSON(value['SteamInAppBillingData']),
        'EgsInAppBillingData': FxIdApplicationStoreInAppInAppValidationRequestEgsInAppBillingDataToJSON(value['EgsInAppBillingData']),
    };
}

